import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';

import {
  InlineMonthControl,
  InlineWeekControl,
  SelectBox,
  Typography,
} from '@oca/ui';
import { Calendar as CalendarIcon } from '@oca/icons';

const calendarByType = {
  month: InlineMonthControl,
  week: InlineWeekControl,
};

const defaultSelectOptions = [
  {
    icon: <CalendarIcon color="currentColor" />,
    value: 'week',
    label: (
      <Typography as="span" color="textSecondary">
        Week
      </Typography>
    ),
  },
  {
    icon: <CalendarIcon color="currentColor" />,
    value: 'month',
    label: (
      <Typography as="span" color="textSecondary">
        Month
      </Typography>
    ),
  },
];

export function VariousCalendar({
  onDateChange,
  onVariantSelect,
  value,
  variant,
  variantOptions,
  disabled,
}) {
  const Calendar = calendarByType[variant] || calendarByType.week;

  return (
    <Flex alignItems="center">
      <Box width={200}>
        <SelectBox
          placeholder="Select time range"
          styles={{
            control: base => ({
              ...base,
              'border-color': 'transparent',
              'background-color': '#F8F9FA',
              'border-radius': '8px',
            }),
            indicatorSeparator: () => ({ visibility: 'hidden ' }),
          }}
          options={variantOptions}
          onChange={onVariantSelect}
          value={variantOptions.find(opt => opt.value === variant) || null}
          menuPortalTarget={document.body}
          getOptionValue={option => option.value}
          getOptionLabel={option => (
            <Flex alignItems="center" color="inherit" lineHeight="20px">
              {option.icon}
              &nbsp;
              {option.label}
            </Flex>
          )}
          disabled={disabled}
        />
      </Box>
      <Calendar onChange={onDateChange} value={value} disabled={disabled} />
    </Flex>
  );
}

VariousCalendar.propTypes = {
  // eslint-disable-next-line react/require-default-props
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onDateChange: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  onVariantSelect: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  variant: PropTypes.oneOf(['month', 'week']),
  variantOptions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ),
};

VariousCalendar.defaultProps = {
  variant: 'week',
  variantOptions: defaultSelectOptions,
};
